export enum StorageKey {
  TOKENS = 'tokens',
  SELECTED_PARTNER_ID = 'selectedPartnerId',
  CHECKOUT_ID = 'checkout-id',
  CHECKOUT_PARTNER_ID = 'partner-id',
  COUNTRIES = 'countries',
  RENEWALS = 'renewals',
  SEEN_CHANGELOG_ENTRIES = 'seenChangelogEntries',
  SEARCH_HISTORY = 'search-history',
  FILTER_PRESETS = 'loftware_filter_presets',
  HIDDEN_TABLE_COLUMNS = 'loftware_table_columns',
  TABLE_COLUMN_WIDTHS = 'loftware_table_column_widths',
}
export const COOKIE_CONSENT_COOKIE_NAME = 'cookie_consent'
export const COOKIE_CONSENT_EXPIRY_DAYS = 365
